import React from 'react';
import {
  Tabs,
  Tab,
  makeStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';

// Custom styles
const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    backgroundColor: 'white',
    marginBottom: theme.spacing(0),
  },
  tab: {
    color: 'white !important',// Default text
    backgroundColor: '#339 !important', // Red background for all tabs
    fontWeight: 'bold',
    fontSize: '0.57rem',
    minWidth: 100,

    '&.Mui-selected': {
      color: '#337 !important',              // Text color when selected
      backgroundColor: '#33337733 !important',     // Keep same red background when selected
    },
    '& .MuiTab-wrapper:hover': {
      backgroundColor: 'transparent !important',
    },
    '&:focus': {
      outline: 'none',               // remove focus outline
    },
    '&:hover': {
      color: '#337 !important',
      backgroundColor: '#33337733 !important',
      //backgroundColor: 'transparent !important',
    },
  },
  disabledtab: {
    color: '#555 !important',// Default text
    backgroundColor: '#777 !important', // Red background for all tabs
    fontWeight: 'bold',
    fontSize: '0.57rem',
    minWidth: 100,

    '&.Mui-selected': {
      color: '#775 !important',              // Text color when selected
      backgroundColor: '#77775533 !important',     // Keep same red background when selected
    },
    '& .MuiTab-wrapper:hover': {
      backgroundColor: 'transparent !important',
    },
    '&:focus': {
      outline: 'none',               // remove focus outline
    },
    '&:hover': {
      color: '#775 !important',
      backgroundColor: '#77775533 !important',
      //backgroundColor: 'transparent !important',
    },
  },
  indicator: {
    backgroundColor: '#339 !important',
    height: 5,
  },
}));

// Custom Tabs component
export default function CustomTabs({ tabs, value, onChange, className, includeAddNew=false}) {
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{
        root: classes.tabsRoot,
        indicator: classes.indicator,
      }}
      className={className}
      variant="scrollable"
      scrollButtons="auto"
    >
      {tabs.map((tab) => (
        <Tab
          wrapped={true}
          key={tab.id}
          label={tab.title}
          className={tab.exists ? classes.tab : classes.disabledtab} // <-- Just use `className` here
        />
      ))}
      { includeAddNew &&
      <Tab icon={<AddIcon />} />
}
    </Tabs>
  );
}
